module.exports = __webpack_public_path__ + "img/pass.ef9c02f5.png";